export const PURCHASE_STEP = {
  COVERAGE: 'coverage',
  BASIC_INFO: 'basic-info',
  DESTINATIONS: 'destinations',
  APPLICANTS: 'group-members',
  REVIEW: 'review',
  PAYMENT: 'payment'
};

export const PURCHASE_STEP_ORDER = [
  PURCHASE_STEP.COVERAGE,
  PURCHASE_STEP.BASIC_INFO,
  PURCHASE_STEP.DESTINATIONS,
  PURCHASE_STEP.APPLICANTS,
  PURCHASE_STEP.REVIEW,
  PURCHASE_STEP.PAYMENT
];
